/**
 * Why the grid is empty, in the user's terms.
 *
 * A catalogue that failed to load must not read as "there are no
 * integrations" — that would send the user off believing the feature does not
 * exist rather than retrying.
 */
export function integrationsEmptyMessage({ error, isLoading }) {
  if (error) return 'Integrations could not be loaded. Please try again.'
  if (isLoading) return 'Loading integrations…'
  return 'No integrations match your filters.'
}
